export const RECORD_USERINFO = 'RECORD_USERINFO';
export const RECORD_ORDERINFO = 'RECORD_ORDERINFO';
export const RECORD_SPECINFO = 'RECORD_SPECINFO';
export const RECORD_PROCESSED_PHOTO = 'RECORD_PROCESSED_PHOTO';
export const RECORD_PROCESSED_PHOTO_NO_FAIR = 'RECORD_PROCESSED_PHOTO_NO_FAIR';
export const RECORD_SELECTED_BG = 'RECORD_SELECTED_BG';
export const RECORD_SEARCH_RESULTS = 'RECORD_SEARCH_RESULTS';
export const RECORD_LAST_SEARCH = 'RECORD_LAST_SEARCH';
export const RECORD_HOTSEARCH = 'RECORD_HOTSEARCH';
export const RECORD_SERVICE_TEL = 'RECORD_SERVICE_TEL';
export const RECORD_CONSIGNEE_INFO = 'RECORD_CONSIGNEE_INFO';
export const RECORD_PRICE = 'RECORD_PRICE';
export const RECORD_PRINTPRICE = 'RECORD_PRINTPRICE';
export const RECORD_PRINT_QTY = 'RECORD_PRINT_QTY';